export const blockIconsEditorModeEdit = (
	<span className='material-symbols-outlined'>mode_edit</span>
);
